<template>
  <div class="lds-ring" :class="size?size:'default'">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: "g-loading",
  props: ["size"],
  data() {
    return {};
  }
};
</script>
 
<style lang="scss" scoped>
@mixin lds-ring($scale) {
  display: inline-block;
  position: relative;
  width: 54px * $scale;
  height: 64px * $scale;
}

.lds-ring.default {
  @include lds-ring(1);
}

.lds-ring.mini {
  @include lds-ring(0.25);
}

@mixin lds-ring-div($scale) {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px * $scale;
  height: 51px * $scale;
  margin: 6px * $scale;
  border: 6px * $scale solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: $gray1 transparent transparent transparent;
}

.lds-ring.default div {
  @include lds-ring-div(1);
}

.lds-ring.mini div {
  @include lds-ring-div(0.3);
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// Loading.vue?57a39ae7